export default function TopMessageV2Skeleton() {
  return (
    <div className="px-5 pt-3 box-border w-full h-14 rounded-300 ">
      <div className="skeleton bg-surface-200-bg w-full h-full"></div>
    </div>
  );
}
